import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, } from 'react';
import { isServer } from '@squareup/util-isomorphic';
import TrackingClient from './client.js';
import EventStreamTrackingClient from './event-stream-client.js';
const TrackingContext = createContext(null);
export function TrackingProvider({ application, environment, shell, userData, session, children, }) {
    const trackingClient = useMemo(() => {
        if (isServer()) {
            // The CDP library is not server-compatible, so return a null client when server-rendering.
            // When the TrackingProvider is hydrated on the client, this code will be re-evaluated and
            // a client will be created.
            return null;
        }
        return new TrackingClient({
            application,
            environment,
            shell,
            userInfo: {
                merchantToken: session?.merchantToken || userData?.user?.token,
                employmentToken: session?.employmentToken || userData?.user?.employment_token,
                personToken: session?.personToken || userData?.user?.person_token,
                loggableSessionToken: session?.loggableSessionToken || userData?.user?.loggable_session_token,
            },
        });
    }, [application, environment, shell, session, userData]);
    return _jsx(TrackingContext.Provider, { value: trackingClient, children: children });
}
export const useTracking = () => useContext(TrackingContext);
const EventStreamTrackingContext = createContext(null);
/** @deprecated Use CDP instead if at all possible */
export function EventStreamTrackingProvider({ applicationName, environment, session, children, }) {
    const trackingClient = useMemo(() => {
        if (isServer()) {
            // This library is not server-compatible, so return a null client when server-rendering.
            // When the TrackingProvider is hydrated on the client, this code will be re-evaluated and
            // a client will be created.
            return null;
        }
        return new EventStreamTrackingClient({
            applicationName,
            environment,
            session,
        });
    }, [applicationName, environment, session]);
    return _jsx(EventStreamTrackingContext.Provider, { value: trackingClient, children: children });
}
/** @deprecated Use CDP instead if at all possible */
export const useEventStreamTracking = () => useContext(EventStreamTrackingContext);
